import { evaluateJsonLogic } from './dependencies';

class Base {
  constructor() {
    // Objects
    this.dependencyIndex = [[]];

    // Strings, since a field can have more than one dependency (uncommon), there's an array. (i.e. show the field and disable the field)
    // Outer array is for a collection of fields (tables usually)
    this.dependencyActions = [[]];
  }

  checkDependencies() {
    this.dependencyIndex.forEach((config, index) => {
      config.forEach((depConfig, depIndex) => {
        if (!this.dependencyActions[index]) {
          this.dependencyActions[index] = [];
        }

        this.dependencyActions[index][depIndex] = evaluateJsonLogic(depConfig);
      });
    });

    return this.dependencyActions;
  }

  // Table of actions might look like: [['entered'], ['entered']]
  hasDependencyAction(dep, index = 0) {
    const actions = this.dependencyActions[index];

    if (!actions) {
      return false;
    }

    for (const action of actions) {
      if (action === dep) {
        return true;
      }
    }

    return false;
  }
}

export default Base;
